import FileCard from './FileCard.jsx'
export default FileCard 